import { Box, Button, Divider, FormGroup, Grid, List, ListItem, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import Tabs from '../../components/Tabs';
import { ITab, ActionTab } from './ActionTab';
import { Link, Select, TextField } from '../../components';
import CasesList from '../VehicleTabs/CasesList';
import { caseService } from '../../services/vehicles';
import { taskOutcomes } from '../../mock/Actions';

interface Props {
  tabs: ITab[];
}

const ActionsTabs = ({ tabs }: Props) => {
  // use hooks
  const { reservationId } = useParams<{ reservationId: string }>();

  // local states
  // const [cases, setCases] = useState<any>([]);

  // HTML Tooltip
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#000',
      color: '#fff',
      maxWidth: 220,
      fontSize: 12,
      fontWeight: 400,
      padding: '10px',
    },
    arrow: {
      '&::before': {
        color: '#000',
        background: '#000',
      },
    },
  }));

  // constants
  const tabItems = tabs?.map((item) => {
    return {
      label: item?.title,
      content: <ActionTab id={item?.id} title={item?.title} />,
    };
  });

  // case data
  // const caseData = cases?.map?.((item: any) => {
  //   return {
  //     title: item?.email,
  //     date: `Date opened: ${moment(item?.openedDate)?.format('MM D, Y hh:mm a')}`,
  //     status: item?.status,
  //   };
  // });

  // fetching record
  // const fetchRecord = useCallback(async () => {
  //   try {
  //     const resp = await caseService({ method: 'POST', data: { reservationId, langCode: 'en-us' } });
  //     setCases(resp?.data?.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }, [reservationId]);

  // lifecycle hook
  // useEffect(() => {
  //   fetchRecord();
  // }, [fetchRecord]);

  return (
    <Box>
      <Tabs tabItems={tabItems} />
      <Grid item xs={12} pt={2}>
        <Stack>
          <Typography fontWeight="500" fontSize={16} lineHeight="24px">
            Next Steps
          </Typography>
          <Divider sx={{ my: 1, borderColor: '#E3E3E3' }} />
          <Box
            sx={{
              borderRadius: '4px',
              border: '1px solid #E3E3E3',
              padding: '8px 20px 0px',
              marginTop: '10px',
              background: '#FFF',
            }}
          >
            <Typography fontSize={16} fontWeight={500} color={(theme) => `#1F1F1F`}>
              Customer Outreach
            </Typography>
            <Box gap={0.5}>
              <Stack divider={<Divider orientation="vertical" flexItem />} direction="row" gap={1.5}>
                <Typography fontSize={12} fontWeight={400}>
                  Assigned to Jereme Belle
                </Typography>
                <Typography fontSize={12} color={(theme) => theme.palette.error.light} fontWeight={400}>
                  Due: Aug 15, 2022 (Today)
                </Typography>
              </Stack>
              <Typography fontSize={12} fontWeight={400}>
                Next contact: Aug 29, 2022 (2 weeks)
              </Typography>
            </Box>
            <List sx={{ flexBasis: '100%', margin: '0', padding: '10px 0 15px 3px' }}>
              <ListItem sx={{ padding: '5px 0' }}>
                <Icon icon="ci:dot-01-xs" />
                <Typography fontSize={14} fontWeight={400} sx={{ color: '#1F1F1F', marginRight: '10px' }}>
                  Advisor introduction
                </Typography>
                <HtmlTooltip
                  sx={{}}
                  title={
                    <>
                      Talking Points: <br />
                      Inform of delivery process <br />
                      Inform of vehicle stage (if reassignment)
                    </>
                  }
                  arrow
                >
                  <Icon icon="bx:comment-detail" color="#333" fontSize="13" />
                </HtmlTooltip>
              </ListItem>
              <ListItem sx={{ padding: '5px 0' }}>
                <Icon icon="ci:dot-01-xs" />
                <Typography fontSize={14} fontWeight={400} sx={{ color: '#1F1F1F' }}>
                  Collect DMV info
                </Typography>
              </ListItem>
              <ListItem sx={{ padding: '5px 0' }}>
                <Icon icon="ci:dot-01-xs" />
                <Typography fontSize={14} fontWeight={400} sx={{ color: '#1F1F1F' }}>
                  Collect registration info
                </Typography>
              </ListItem>
              <ListItem sx={{ padding: '5px 0' }}>
                <Icon icon="ci:dot-01-xs" />
                <Typography fontSize={14} fontWeight={400} sx={{ color: '#1F1F1F' }}>
                  Collect delivery info
                </Typography>
              </ListItem>
            </List>
            <FormGroup>
              <Box gap={1} display="flex" flexDirection="column" flexWrap="wrap">
                <Grid container spacing={1.375}>
                  <Grid item xs={3}>
                    <Select title="Task outcome" options={taskOutcomes} />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      type="text"
                      name=""
                      placeholder="mm/dd/yyyy"
                      sx={{ fontSize: '12px', height: '36px', borderRadius: '4px' }}
                    />
                    <Typography fontSize={10} fontWeight={400} sx={{ color: '#717171', paddingTop: '3px' }}>
                      Postpone next contact if needed
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField placeholder="Enter comment" sx={{ fontSize: 12, height: 36 }} />
                  </Grid>
                </Grid>
                <Grid container gap={1.375} alignItems="center" justifyContent="flex-end" mt={0}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        textTransform: 'none',
                        height: 'fit-content',
                        fontSize: '12px',
                        padding: '10px',
                        lineHeight: 'inherit',
                        fontWeight: '400',
                      }}
                    >
                      Mark as Complete
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </FormGroup>
          </Box>
        </Stack>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={20} fontWeight={500}>
            Cases
          </Typography>
          <Link to="/" sx={{ fontSize: 14, fontWeight: 400, color: '#456BD9' }}>
            View all cases
          </Link>
        </Stack> */}
        {/* <CasesList cases={caseData} /> */}
      </Grid>
    </Box>
  );
};

export default ActionsTabs;
